module.exports = __webpack_public_path__ + "static/media/VOLKSWAGEN.3f69ed4a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/VOLKSWAGEN.png
 ** module id = 1661
 ** module chunks = 0
 **/